<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <div id="my-table-id">
                <v-data-table :headers="headers" :items="salary_sub_component_list" dense class="elevation-1 mytable"
                    :search="search">
                    <template v-slot:top>
                        <v-toolbar dense class="toolbar" flat color="white">
                            <v-toolbar-title>Salary Sub Component</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <span style="width: 20px;"> </span>
                        <v-row dense>
                            <v-col cols="12" sm="3" md="3">

                                <v-btn rounded color="success" outlined
                                    @click="fnExcelReport('my-table-id', 'SalarySubComponent')"
                                    :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                            </v-col>
                            <v-col sm="6" md="4" cols="12">
                                <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                    hide-details> </v-text-field>
                            </v-col>
                            <span style="width: 20px;"></span>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn class="mb-2 button" v-on="on" small>Add Salary Sub Component</v-btn>
                                </template>
                                <v-card>
                                    <v-form v-model="valid">
                                        <v-card-title class="toolbar">
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" sm="12" md="12">
                                                        <v-text-field v-model="editedItem.component_sub_name"
                                                            persistent-hint :hint="editedIndex == -1
                                                                ? 'For example :: LIC1, LIC2, LIC3...'
                                                                : 'For example :: LIC1, LIC2, LIC3...'
                                                                " label="Salary Sub Component Name"
                                                            :rules="[(v) => !!v || 'required']">
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>

                                                    <v-col cols="12">
                                                        <v-text-field v-model="editedItem.component_sort_order"
                                                            label="Component Sort Order" hint="1, 2, 3..."
                                                            :rules="[(v) => !!v || 'required']"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-select dense v-model="editedItem.component_salary_id"
                                                            :items="salarycomponent_list" item-text="display_name"
                                                            item-value="component_salary_id"
                                                            label="Select Salary Component" persistent-hint :hint="editedIndex == -1
                                                                ? 'Select Component :: grade, grade pay,professional tax...'
                                                                : 'Select Component :: grade, grade pay,professional tax...'
                                                                " single-line></v-select>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-checkbox v-model="editedItem.status" color="success"
                                                            label="Active"></v-checkbox>
                                                    </v-col>


                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                            <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                        </v-card-actions>
                                    </v-form>
                                </v-card>
                            </v-dialog>
                        </v-row>
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-switch v-model="item.status" inset color="success" @change="toggleGroup(item)"></v-switch>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div>
                            <v-avatar style="" size="25" class="edit-avatar">
                                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                </v-data-table>
            </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

    data: () => ({
        valid: false,
        overlay: false,
        // extraBreadcrumbItems: [
        //     { text: "Salary Sub Component", disabled: true, href: "" },

        // ],
        // breadcrumbClass: "breadcrumb-style1",
        errorMsg: {
            id: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        headers: [
            {
                text: "Sr No.",
                align: "left",
                value: "srno",
            },
            {
                text: "Component Sub Name",
                align: "left",
                value: "component_sub_name",
            },
            {
                text: "Salary Component",
                align: "left",
                value: "component_salary",
            },
            {
                text: "Sort Order",
                align: "left",
                value: "component_sort_order",
            },
            {
                text: "Status",
                align: "left",
                sortable: false,
                value: "status",
            },
            { text: "Actions", value: "action", sortable: false },
        ],
        table_fields: {
            "Sr No.": "srno",
            "Component Sub Name": "component_sub_name",
            "Salary Component": "component_salary",
            "Sort Order": "component_sort_order",
        },
        salary_sub_component_list: [],
        salarycomponent_list: [],
        editedIndex: -1,
        editedItem: {
            id: 0,
            component_sub_name: "",
            status: true,
            component_sort_order: "",
            component_salary_id: "",
        },
        defaultItem: {
            id: 0,
            component_sub_name: "",
            status: true,
            component_sort_order: "",
            component_salary_id: "",
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Salary Sub Component" : "Edit Salary Sub Component";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },

    mounted() {
        this.onLoad();
    },
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
    <tr>
      <th>Sr.No.</th>
      <th>Component Sub Name</th>
      <th>Salary Component</th>
      <th>Sort Order</th>
      
    </tr>`;

            this.salary_sub_component_list.forEach((item, index) => {
                tab_text += `
    <tr>
        <td>${index + 1}</td> 
        <td>${item.component_sub_name || ''}</td> 
        <td>${item.component_salary || ''}</td> 
        <td>${item.component_sort_order || ''}</td> 
    </tr>`;
            });

            tab_text += '</table>';

            const blob = new Blob([tab_text], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        toggleGroup(item) {
            const formData = {
                id: item.id,
                status: item.status,
            };
            axios
                .post("/Payroll/toggleSalarySubComponentStatus", formData)
                .then((res) => {
                    if (res.data.status.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Salary Sub Component Status Changed...");
                    } else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                });
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/Payroll/salarySubComponent")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.overlay = false;
                        this.salary_sub_component_list = res.data.component_sub_list;
                        this.salarycomponent_list = res.data.salarycomponent_list;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    var overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        editItem(item) {
            this.editedIndex = this.salary_sub_component_list.indexOf(item);
            this.editedItem.id = item.id,
                this.editedItem.component_salary_id = item.component_salary_id;
            this.editedItem.component_sort_order = item.component_sort_order,
                this.editedItem.status = item.status;
            this.editedItem.component_sub_name = item.component_sub_name;
            this.dialog = true;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                console.log("1");
                if (this.isValidated()) {
                    console.log("2");
                    axios
                        .post("/Payroll/editSalarySubComponent", this.editedItem)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                Object.assign(this.salary_sub_component_list[this.editedIndex], this.editedItem);
                                this.onLoad();
                                this.showSnackbar("#4caf50", "Salary Sub Component Updated Successfully..."); // show snackbar on success
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Salary Sub Component Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            } else {
                console.log("save api data");
                console.log(this.editedItem);
                axios
                    .post("/Payroll/saveSalarySubComponent", this.editedItem)
                    .then((res) => {
                        if (res.data.status.code == "SUCCESS") {
                            // this.salary_component_list.push(this.editedItem);
                            this.onLoad();
                            this.showSnackbar("#4caf50", "Salary Sub Component Added Successfully..."); // show snackbar on success
                        } else if (res.data.status.code == "NA") {
                            this.showSnackbar("#b71c1c", "Salary Sub Component Already Present!!!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });

                this.close();
            }
        }, // end of save()

        isValidated() {
            if (this.editedItem.component_sub_name) {
                return true;
            } else {
                return false;
            }
        }, // .....end of isValidated()
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
